import React, { Component } from 'react'
import 'worldwindjs'
import request from '../../utils/request'
import { iconRotate } from '../../utils'
import { osintRequestAddress } from '../config'

const countryDict = {
    "United States": "美国",
    "Japan": "日本",
    "Taiwan": "台湾",
    "South Korea": "韩国",
    "India": "印度",
    "Australia": "澳大利亚",
    "Russia": "俄罗斯",
}

/* global WorldWind */
export default class PlanesLayer extends Component {
    state = {
        isPlaneListGot: false,
    }
    // 飞机图标配置
    static planeIcons = [
        `data:image/png;base64,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`,
        "./plane.png",
        "./greyplane.png",
    ];

    componentDidMount() {
        if (this.state.isPlaneListGot) {
            return
        }
        // Create a placemark using the selected marker image
        let attributes = new WorldWind.PlacemarkAttributes(null);
        attributes.imageScale = 2;   //正常飞机图标
        // attributes.imageScale = 0.001;  // 当显示3d飞机模型时，将原飞机图标缩小
        attributes.imageOffset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 0.5);
        attributes.imageColor = WorldWind.Color.WHITE;
        attributes.labelAttributes.offset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 1.8);
        attributes.labelAttributes.color = WorldWind.Color.YELLOW;
        attributes.labelAttributes.scale = 2.5;
        attributes.drawLeaderLine = true;
        attributes.leaderLineAttributes.outlineColor = WorldWind.Color.RED;
        attributes.imageSource = PlanesLayer.planeIcons[0];

        let lineAttributes = new WorldWind.ShapeAttributes();
        lineAttributes.outlineColor = WorldWind.Color.YELLOW;
        lineAttributes.outlineWidth = 3;

        const token = localStorage.getItem('token')
        request({
            url: `${osintRequestAddress}/plane?icao=all`,
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(
            response => {
                if (response && response.length > 0) {
                    var lastPosition = { latitude: 0, longitude: 0, altitude: 0 }
                    response.map(
                        (plane) => {
                            //不显示没有reg属性值的飞机
                            if (plane.reg === "") {
                                return ""
                            }
                            //
                            var positions = []
                            plane.poses.map((pos) => {
                                positions.push(new WorldWind.Position(pos.lat, pos.lon, pos.alt))
                                lastPosition = { latitude: pos.lat, longitude: pos.lon, altitude: pos.alt, trak: pos.trak }
                                return ""
                            })
                            let track = new WorldWind.Path(positions, lineAttributes)
                            let placemark = new WorldWind.Placemark(lastPosition, /*eyeDistanceScaling*/ true, attributes)
                            
                            // placemark.imageRotation = lastPosition.trak  // 机头朝上的图标
                            placemark.imageRotation = iconRotate(lastPosition.trak, -90)  // 根据图标机头与正北角度差调整方向角
                            placemark.type = 'plane'
                            if (plane.reg !== "") {
                                placemark.label = countryDict[plane.cou] + plane.type + " " + plane.reg
                            } else {
                                placemark.label = countryDict[plane.cou] + plane.type + " " + plane.icao
                            }
                            placemark.eyeDistanceScalingThreshold = 2500000;
                            placemark.eyeDistanceScalingLabelThreshold = 5000000;
                            // Add the line and marker to the layer and to the Markers component      
                            const globe = this.props.globe;
                            const layer = globe.getLayer(this.props.markersLayerName);
                            if (layer) {
                                // Add the line to the globe
                                if (positions.length > 1) {
                                    layer.addRenderable(track);     //必须多于1个轨迹点才能绘制轨迹，否则组件会报错
                                }
                                layer.addRenderable(placemark)
                                
                                // for test 3d
                                // var config3d = {dirPath: './3ds/'};
                                // var colladaLoader = new WorldWind.ColladaLoader(lastPosition, config3d);
                                // colladaLoader.load("Su-57.dae", function (scene) {
                                //     scene.scale = 5000;
                                //     scene.label = countryDict[plane.cou] + plane.type + " " + plane.icao
                                //     scene.eyeDistanceScalingThreshold=2500000;
                                //     // scene.zRotation  = lastPosition.trak;
                                //     scene.zRotation  = iconRotate(lastPosition.trak, -90);
                                //     layer.addRenderable(scene);
                                // });
                                // end of for test

                                // send the planes to the Markers component                            
                                this.props.addPlane(placemark, plane)
                            } else {
                                console.warn("Renderable layer for lines not found: " + this.props.markersLayerName);
                            }
                            return ""
                        }
                    )
                    this.setState({ isPlaneListGot: true })
                }
            },
            error => { console.log("error", error) }
        )
    }
    render() {
        return <div></div>
    }
}
